import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getMap } from "../services/mapServices";

export function useMap(mapId) {

  const map = useQuery({
    queryKey: ["Map", mapId],
    queryFn: () => getMap({ mapId: mapId }),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!mapId,
  });

  return {
    map: map.data || null,
    isLoadingMap: map.isLoading,
    refetchMap: map.refetch,
  };
}
